import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"

const Notes = (props) => {

    return (
        <Page padding={false}>
            {props.campaignText || props.campaignDetailText ?
                <Panel hasFooter={false} noHeader className="notes-container accordion-container">
                    <Block dangerouslySetInnerHTML={{ __html: props.campaignText }} />
                    <List
                        accordion
                        accordionCollapsible
                        activeItem={0}
                        custom={false}
                        disabled={false}
                        expandOnlyOne
                        withPadding
                        withoutBorder={false}
                        className="campaign-list-title"
                    >
                        <List.Item
                            accordion={false}
                            accordionCollapsible
                            disabled={false}
                            preventDefault
                            title="Kampanya Detayları"
                            withPadding={true}
                            className="campaign-list-item"
                        >
                            <Block dangerouslySetInnerHTML={{ __html: props.campaignDetailText }} />
                        </List.Item>
                    </List>
                </Panel>
                : null}
        </Page>
    )
}

export default Notes
